import React from 'react';
import { Plus, X } from 'lucide-react';
import type { RodeoRow } from '../../libs/inventoryCalc';
import '../landing/brand.css';

const CATS = [
  { v: 'terneros', l: 'Terneros' },
  { v: 'terneras', l: 'Terneras' },
  { v: 'novillos', l: 'Novillos' },
  { v: 'vaquillonas', l: 'Vaquillonas' },
  { v: 'vacas', l: 'Vacas' },
  { v: 'toros', l: 'Toros' },
];

const grid: React.CSSProperties = { display: 'grid', gridTemplateColumns: 'minmax(0,1.4fr) minmax(0,1fr) minmax(0,1fr) 36px', gap: 8, alignItems: 'center' };

/**
 * Builder de filas del rodeo para la calculadora de inventario (manual de marca v1.0).
 * Cada fila: categoría (select) + cabezas + peso. La persistencia la maneja
 * la página (localStorage); este componente es controlado (`rows`/`onChange`).
 */
const RodeoBuilder: React.FC<{
  rows: RodeoRow[];
  onChange: (rows: RodeoRow[]) => void;
}> = ({ rows, onChange }) => {
  const update = (i: number, patch: Partial<RodeoRow>) =>
    onChange(rows.map((r, idx) => (idx === i ? { ...r, ...patch } : r)));
  const add = () => onChange([...rows, { categoria: 'novillos', cabezas: 0, peso: 0 }]);
  const remove = (i: number) => onChange(rows.filter((_, idx) => idx !== i));

  return (
    <div className="lp-scope" style={{ display: 'grid', gap: 8 }}>
      <div style={grid} className="lp-note" aria-hidden="true">
        <span>Categoría</span>
        <span>Cabezas</span>
        <span>Peso prom. (kg)</span>
        <span />
      </div>
      {rows.map((r, i) => (
        <div key={i} style={grid}>
          <select
            className="lp-control"
            value={r.categoria}
            onChange={(e) => update(i, { categoria: e.target.value })}
            aria-label="Categoría"
          >
            {CATS.map((c) => (
              <option key={c.v} value={c.v}>
                {c.l}
              </option>
            ))}
          </select>
          <input
            type="number"
            min={0}
            inputMode="numeric"
            className="lp-control"
            placeholder="Cabezas"
            value={r.cabezas || ''}
            onChange={(e) => update(i, { cabezas: parseFloat(e.target.value) || 0 })}
            aria-label="Cabezas"
          />
          <input
            type="number"
            min={0}
            inputMode="decimal"
            className="lp-control"
            placeholder="Peso kg"
            value={r.peso || ''}
            onChange={(e) => update(i, { peso: parseFloat(e.target.value) || 0 })}
            aria-label="Peso promedio kg"
          />
          <button
            type="button"
            onClick={() => remove(i)}
            className="lp-btn lp-btn--ghost lp-btn--xs"
            style={{ padding: 0, width: 36 }}
            aria-label="Quitar fila"
          >
            <X aria-hidden="true" />
          </button>
        </div>
      ))}
      <div>
        <button type="button" onClick={add} className="lp-link" style={{ marginTop: 6, fontSize: 15 }}>
          <Plus aria-hidden="true" /> Agregar categoría
        </button>
      </div>
    </div>
  );
};

export default RodeoBuilder;
